import { components } from "types/openapi";
import { ETH_SUPPORTED_TOKENS, TRX_SUPPORTED_TOKENS } from "utils/envConstants";
import { ExpandNetworkType, CONTRACT_CURRENCY_ENUM, NETWORK_TEXT } from "./contracts";

export type WalletEntity = {
  id: string;
  network: "ETH" | "TRX";
  address: string;
};
export type WalletRequest = components["schemas"]["WalletRequestDto"];
export type TransactionType = components["schemas"]["RequestTxGridDto"]["type"];

export const TRANSACTION_TYPE_TEXT: Record<TransactionType, string> = {
  IN: "Входящая",
  OUT: "Исходящая",
};

export const NETWORK_TOKENS_MAP: Record<ExpandNetworkType, string[]> = {
  ETH: ETH_SUPPORTED_TOKENS,
  TRX: TRX_SUPPORTED_TOKENS,
};

export const getSupportedTokensByNetwork = (network: ExpandNetworkType): string[] => {
  return NETWORK_TOKENS_MAP[network] || [];
};

export const getTokensAsOptions = (network: ExpandNetworkType): Record<string, string> => {
  const tokens = getSupportedTokensByNetwork(network);
  return tokens.reduce(
    (acc, token) => {
      acc[token] = token;
      return acc;
    },
    {} as Record<string, string>
  );
};

export const getDigitalCurrencyTypesByNetwork = (network: ExpandNetworkType): Record<string, string> => {
  return getTokensAsOptions(network);
};

const createCurrencyNetworksMap = (): Record<keyof typeof CONTRACT_CURRENCY_ENUM, ExpandNetworkType[]> => {
  const result: Record<keyof typeof CONTRACT_CURRENCY_ENUM, ExpandNetworkType[]> = {} as Record<
    keyof typeof CONTRACT_CURRENCY_ENUM,
    ExpandNetworkType[]
  >;

  Object.keys(CONTRACT_CURRENCY_ENUM).forEach((currency) => {
    const currencyKey = currency as keyof typeof CONTRACT_CURRENCY_ENUM;
    result[currencyKey] = [];

    Object.entries(NETWORK_TOKENS_MAP).forEach(([network, tokens]) => {
      if (tokens.includes(CONTRACT_CURRENCY_ENUM[currencyKey])) {
        result[currencyKey].push(network as ExpandNetworkType);
      }
    });
  });

  return result;
};

export const CURRENCY_NETWORKS_MAP = createCurrencyNetworksMap();

export const getNetworksByCurrency = (currency: keyof typeof CONTRACT_CURRENCY_ENUM): ExpandNetworkType[] => {
  return CURRENCY_NETWORKS_MAP[currency] || [];
};

export const getNetworksAsOptionsByCurrency = (
  currency: keyof typeof CONTRACT_CURRENCY_ENUM,
  iconPicker?: (network: string, networkText: string) => React.ReactNode
): Record<string, string> | Array<{ key: string; value: string; icon?: React.ReactNode }> => {
  const networks = getNetworksByCurrency(currency);

  if (iconPicker) {
    return networks.map((network) => ({
      key: network,
      value: NETWORK_TEXT[network],
      icon: iconPicker(network, NETWORK_TEXT[network]),
    }));
  }

  return networks.reduce(
    (acc, network) => {
      acc[network] = NETWORK_TEXT[network];
      return acc;
    },
    {} as Record<string, string>
  );
};
